function assign(o1, o2) {
  for (var i in o2) {
    o1[i] = o2[i];
  }
  return o1;
}
function onHashChange(cb) {
  window.addEventListener('hashchange', function () {
    cb({
      page_id: location.hash || '#'
    });
  });
}
function onHistoryChange(cb) {
  window.addEventListener('popstate', function (e) {
    cb(e.state);
  });
  var originPushState = window.history.pushState;
  if (originPushState) {
    history.pushState = function (state) {
      originPushState.apply(this, arguments);
      cb(state);
    };
  }
  var originReplaceState = window.history.replaceState;
  if (originReplaceState) {
    history.replaceState = function (state) {
      originReplaceState.apply(this, arguments);
      cb(state);
    };
  }
}

// autolog插件中也会监听相应事件，这里的数据上报在延迟触发，保证blur到focus、hidden到visible之间没有任何数据上报
// 延迟时间做了处理，按照blur hidden visible focus的顺序上报，至少保证hidden/visible是连着的
function onPageStatusChange(cb) {
  window.addEventListener('visibilitychange', function () {
    setTimeout(function () {
      cb(document.hidden ? 'hidden' : 'visible');
    }, document.hidden ? 300 : 100);
  });
  window.addEventListener('blur', function (e) {
    setTimeout(function () {
      cb('blur');
    }, 200);
  });
  window.addEventListener('focus', function () {
    setTimeout(function () {
      cb('focus');
    }, 200);
  });
}
function ETrackerPluginPV(etracker, config) {
  var referrer = document.referrer;
  var preReferrer = referrer;
  var firstPv = true;
  var plugin_config = assign(assign({}, etracker.getConfig('plugin_pv')), config);
  var _plugin_config$autoPV = plugin_config.autoPV,
    autoPV = _plugin_config$autoPV === void 0 ? true : _plugin_config$autoPV,
    _plugin_config$autoLe = plugin_config.autoLeave,
    autoLeave = _plugin_config$autoLe === void 0 ? true : _plugin_config$autoLe,
    enableHistory = plugin_config.enableHistory,
    enableHash = plugin_config.enableHash;
  function getParam(preReferrer) {
    return {
      p1: preReferrer || referrer
    };
  }
  function sendPV() {
    if (firstPv) {
      firstPv = false;
    } else {
      etracker.updatePVID();
    }
    etracker.log('pv', getParam());
    preReferrer = referrer;
    referrer = location.href;
  }
  function sendLeave() {
    etracker.log('leave', getParam(preReferrer));
  }
  function switchPage(config) {
    if (config) {
      etracker.setConfig(config);
    }
    sendPV();
  }
  if (autoPV) {
    sendPV();
  }
  if (enableHistory && autoPV) {
    onHistoryChange(function () {
      sendPV();
    });
  } else if (enableHash && autoPV) {
    onHashChange(function () {
      sendPV();
    });
  }
  if (autoLeave) {
    window.addEventListener('beforeunload', function () {
      sendLeave();
    });
  }
  onPageStatusChange(function (p1) {
    etracker.log('pagestatuschange', {
      p1: p1
    });
  });
  return {
    sendPV: sendPV,
    sendLeave: sendLeave,
    switchPage: switchPage
  };
}

export { ETrackerPluginPV as default };
